import { cva } from '@/styled-system/css';

export const comboboxOptionMetaRecipe = cva({
  base: {
    display: 'block',
    gridArea: 'meta',
    color: { base: 'Combobox.OptionMeta.text.meta.default' },
    textStyle: 'body',
  },
  variants: {
    disabled: {
      true: {},
      false: {
        color: {
          _groupHover: 'Combobox.OptionMeta.text.meta.hover',
          _groupActive: 'Combobox.OptionMeta.text.meta.pressed',
        },
      },
    },
    selected: {
      true: {
        color: { base: 'Combobox.OptionMeta.text.meta.selected' },
      },
      false: {},
    },
  },
});
